module.exports = __webpack_public_path__ + "img/Team-AnthonyLambkin.521c90e9.png";